// extracted by mini-css-extract-plugin
export var closeButton = "_mi-1";
export var closeX = "_mi-3";
export var container = "_mi-0";
export var image = "_mi-2";